import { render, staticRenderFns } from "./ARAPSummary.vue?vue&type=template&id=22e2a282&scoped=true&"
import script from "./ARAPSummary.vue?vue&type=script&lang=js&"
export * from "./ARAPSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2a282",
  null
  
)

export default component.exports